var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseEditorTemplate',_vm._b({attrs:{"block":_vm.block,"tooltip":_vm.$t(("questionmark." + (_vm.block.assignment)))}},'BaseEditorTemplate',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }